/** Platform permission keys used by the UI (identity contract §6; the API checks the same keys). */
export const platformPermissions = {
  userView: "platform.user.view",
  userCreate: "platform.user.create",
  userUpdate: "platform.user.update",
  roleView: "platform.role.view",
  roleCreate: "platform.role.create",
  roleUpdate: "platform.role.update",
  roleDelete: "platform.role.delete",
  sessionPolicyView: "platform.session_policy.view",
  sessionPolicyUpdate: "platform.session_policy.update",
  auditView: "platform.audit.view",
  settingsView: "platform.settings.view",
  settingsUpdate: "platform.settings.update",
  /** Device profiles and the device settings group (ADR-0014/D-5, owned by the Device module). */
  deviceProfileView: "device.device_profile.view",
  deviceProfileUpdate: "device.device_profile.update",
  tenantExport: "platform.tenant.export",
  messagingSettingsView: "platform.sms_config.view",
  messagingSettingsUpdate: "platform.sms_config.update",
  messageTemplateView: "platform.sms_template.view",
  messageTemplateUpdate: "platform.sms_template.update",
  outgoingMessageView: "msg.outgoing_message.view",
  /** Number series per company (ADR-0006). */
  numberSeriesView: "platform.number_series.view",
  numberSeriesUpdate: "platform.number_series.update",
  /** Approval templates (G3, legacy menu 275) and the approval logs / inbox (legacy menu 238). */
  approvalTemplateView: "platform.approval_templates.view",
  approvalTemplateUpdate: "platform.approval_templates.update",
  approvalLogView: "platform.approval_vouchers_logs.view",
  /** Share saved table views with everyone and change shared views (UX8). */
  listViewsManage: "platform.list_views.manage",
} as const;
